import { Component, OnInit, Input, Output, ViewChild, ContentChild, EventEmitter, TemplateRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'snc-modal',
  templateUrl: './snc-modal.component.html',
  styleUrls: ['./snc-modal.component.css']
})
export class SncModalComponent implements OnInit {

  @ViewChild('modal') modal: ModalDirective;

  @Output() yes: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() no: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ContentChild('modalBodyTemplate') modalBodyTemplate: TemplateRef<any>;
  @Input('s-title') title: string;
  @Input('s-message-body') messageBody: string;
  @Input('s-css-modal-header') cssModalHeader = '';
  @Input('s-css-modal-body') cssModalBody = '';
  @Input('s-css-modal-footer') cssModalFooter = '';
  @Input('s-label-btn-yes') labelBtnYes = '';
  @Input('s-label-btn-no') labelBtnNo = '';
  @Input('s-show-btn-yes') showBtnYes = true;
  @Input('s-show-btn-no') showBtnNo = true;
  @Input('s-show-btn-close') showBtnClose = true;

  constructor() { }

  ngOnInit() {
  }

  show() {
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  submit() {
    this.yes.emit(true);
  }

  close() {
    this.no.emit(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/custom/snc-modal/snc-modal.component.ts